import Image from "next/image";
import { twMerge } from "tailwind-merge";
import { ButtonTransparentRounded } from "../../stories/Button.stories";
import Button from "./Button";

interface HalfCardProps {
    backgroundColor: string;
    textColor?: string;
    title?: string;
    subTitle?: string;
    titleDescription?: string;
    firstButtonText?: string;
    secondButtonText?: string;
    buttonBorderColor?: string;
    text?: string;
    img: string;
}

export default function HalfCard({
    backgroundColor,
    textColor,
    title,
    subTitle,
    titleDescription,
    firstButtonText,
    secondButtonText,
    buttonBorderColor,
    text,
    img,
}: HalfCardProps) {
    return (
        <div
            className={twMerge(
                "w-full  min-h-[968px] px-3 md:px-20 lg:px-20 py-36 pt-15  flex-col justify-center items-center gap-8 inline-flex",
                backgroundColor,
            )}
        >
            <div
                className={twMerge(
                    "mx-auto pt-10 text-center text-xl3 lg:text-5xl font-bold  leading-14",
                    textColor,
                )}
            >
                {title}
            </div>

            <div>
                <div
                    className={twMerge(
                        "text-center mx-auto  text-2xl font-bold  leading-loose",
                        textColor,
                    )}
                >
                    {subTitle}
                </div>
                <div
                    className={twMerge(
                        "lg:mx-24 md:px-20 text-center text-xl font-normal leading-7",
                        textColor,
                    )}
                >
                    {titleDescription}
                </div>
            </div>
            <div className="text-center mx-auto space-y-2">
                <Button
                    backgroundColor={ButtonTransparentRounded.args?.backgroundColor}
                    border={twMerge(buttonBorderColor, "border border-2")}
                    hasIcon={ButtonTransparentRounded.args?.hasIcon}
                    paddings="py-2 px-6"
                    rounded={ButtonTransparentRounded.args?.rounded}
                    size={"w-fit min-h-14.5"}
                    textColor={textColor}
                    textSize="text-xl lg:text-2xl font-bold"
                    text={firstButtonText}
                />
                <div className="flex justify-center mx-auto h-fit">
                    <Image
                        alt=""
                        height={200}
                        width={100}
                        className="h-fit w-fit"
                        src={img}
                    />
                </div>

                <Button
                    backgroundColor={ButtonTransparentRounded.args?.backgroundColor}
                    border={twMerge(buttonBorderColor, "border border-2")}
                    hasIcon={ButtonTransparentRounded.args?.hasIcon}
                    paddings="py-2 px-6"
                    rounded={ButtonTransparentRounded.args?.rounded}
                    size={"w-fit min-h-14.5"}
                    textColor={textColor}
                    textSize="text-xl lg:text-2xl font-bold"
                    text={secondButtonText}
                />
            </div>
            <div
                className={twMerge(
                    "text-center text-xl1 font-normal leading-8.5",
                    textColor,
                )}
            >
                {text}
            </div>
        </div>
    );
}
